<script>
  import { onMount, onDestroy } from "svelte";
  import request from 'superagent';
  import { createEventDispatcher } from 'svelte';
  import Editor from './editor.svelte';
  const dispatch = createEventDispatcher();
  
  const defaultParagraph = {name: 'x', content: 'xdddxx'};
  
  export let article = null
  
  let paragraphs = [Object.assign({}, defaultParagraph), Object.assign({}, defaultParagraph)];
  
  onMount(() => {
    // TODO load paragraphs for defined act template
  })
  
  export function dragstart(e) {
    var component = {
      type: 'paragraph',
      name: e.target.getAttribute('name'),
      content: e.target.getAttribute('content')
    }
    e.dataTransfer.setData("text/plain", JSON.stringify(component));
  }
</script>
<button class='btn btn-outline-success btn-sm'>
<i class='fa fa-plus'></i>
</button>
<div class='card'>
<div class='list-item-group'>
{#each paragraphs as {name, content}, i}
<div class='list-item p-1' content='{content}' draggable='true' name='{name}' on:dragstart='{event => dragstart(event)}' target='_blank'>
<p class='ml-2 mb-1'>
<Editor content='{content}' visible_font_sizes='{false}'>
<label class='form-text text-muted' for='document-acticle-paragraph'>
{i+1} {name}
</label>
</Editor>
</p>
</div>
{/each}
</div>
</div>
